module.exports = __webpack_public_path__ + "img/img_service_02.dbb562c3.jpg";